import type { User } from 'common/src/utils/types';

export const canRegisterShipmentPrices = (
  userProfile: User | null | undefined
): boolean =>
  Boolean(
    userProfile &&
      !userProfile.exporter?.hasDemo &&
      (userProfile.roles.some(
        (role) => role === 'admin' || role === 'superadmin'
      ) ||
        (userProfile.roles.includes('basic') &&
          userProfile.permissions?.some(
            (permission) =>
              permission.enabled &&
              ['daily-market', 'evolution-market'].includes(
                permission.sidebarItemKey
              )
          )))
  );
